var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup50(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.446,
    height: 76.067,
    viewBox: "0 0 73.446 76.067",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(-141.859 -138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M242.151,180.616l-2.107-2.155a1.248,1.248,0,0,0-1.7-.074l-.053.048-18.584,16.039-16.787,14.484-11.436-11.087a1.24,1.24,0,0,0-1.845.135l-6.33,8.241a1.232,1.232,0,0,0,.1,1.622l18.579,18.75a1.238,1.238,0,0,0,.879.372h.039a1.27,1.27,0,0,0,.9-.42l22.291-25.7,16.083-18.54.022-.026A1.246,1.246,0,0,0,242.151,180.616Z",
    transform: "translate(-27.207 -26.476)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M179.892,214.067a38.033,38.033,0,1,1,26.895-64.928l-6.183,6.182a29.29,29.29,0,1,0,0,41.425l6.183,6.182A37.789,37.789,0,0,1,179.892,214.067Z",
    transform: "translate(0)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup50);
export default __webpack_public_path__ + "static/media/Group 50.e5258e379b871591d5268032696ec745.svg";
export { ForwardRef as ReactComponent };